import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals, Ref } from '../globals';
import { PrVnta } from './product-vnta.service';

export interface Student {
  active: boolean;
  createdAt: any;
  updatedAt: any;

  name: string;
  birthdate: string;
  semester: number;
  assignments: string[];

  prVntaRef: Ref;
}

interface StudentId extends Student {
  id: string;
  prVntaObj: PrVnta;
}

@Injectable()
export class StudentService {

  studentCollection: AngularFirestoreCollection<Student>;
  students: any;

  studentDocument: AngularFirestoreDocument<StudentId>;
  student: Observable<StudentId>;

  collection: string;
  prVntaCollection: string;

  // NOTE: Change this any for Student Interface
  student$: Observable<any>;
  students$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    this.collection = Globals.STUDENT_COLLECTION;
    this.prVntaCollection = Globals.PRVNTA_COLLECTION;
  }

  /**
   * Get all students with references
   * @return {Observable} Arrays of students
   */
  getStudents(): Observable<StudentId[]> {
    return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
  }

  /**
  * Get student data
  * @param {string} sid - The id of the student
  * @return {Observable} The Student Object
  */
  getStudent(sid: string): Observable<StudentId[]> {
      return this.afh.docWithIds$(this.collection + '/' + sid).map((document: StudentId) => {
        const prVntaRef = this.afh.docWithIds$(`${document.prVntaRef.path}`);
        return Observable.combineLatest(
          prVntaRef,
          (prVntaData) => ({ prVnta: prVntaData })
        ).map(data => ({ prVntaObj: data.prVnta, ...document }) );
      }).mergeMap(docs => Observable.combineLatest(docs));
  }

  /**
  * Create new student
  * @param {Student} student - The data of the student
  */
  addStudent(student: Student) {
    this.afh.add(`${this.collection}`, student);
  }

  /**
   * Update current student
   * @param {string} sid  - The id of the student
   * @param {Student} student - The data of the student
   */
  updateStudent(sid: string, student: Student) {
    this.afh.update(`${this.collection}/${sid}`, student);
  }

  /**
   * Delete current student
   * @param {string} sid - The id of the student
   */
  deleteStudent(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  prVntaReference(id: string){
    return this.afh.doc(`${this.prVntaCollection}/${id}`).ref;
  }

  windowReplace(action: string, id?: string){
    switch(action){
      case 'add':
      case 'create':
        this.router.navigate([`/new_student`]);
        break;
      case 'edit':
      case 'update':
        this.router.navigate([`/edit_student/${id}`]);
        break;
      case 'view':
      case 'display':
        this.router.navigate([`/vw_student/${id}`]);
        break;
      case 'read':
        this.router.navigate([`/student`]);
        break;
      default:
        console.log('Not an action');
    }
  }
}

export class StudentData {
  
  assignments = {
    key0: 'Grammar',
    key1: 'Math',
    key2: 'Social studies',
  }
}
